
<script>

import { defineComponent } from 'vue'

import { useToast } from "vue-toastification";

//data
import { getLibraryInfo, getLibraryOptions } from '@/services/serviceLibrary';
import { getDocumentsByLibrary } from '@/services/serviceDocument';

export default defineComponent({
	setup() {
		const toast = useToast();
		return { toast }
	},
  name: 'OneDocumentToArticle',
	data() {
		return {
			preloader:false,
			library: [],
			docs: [],
			optionsLibraries: [],
			selectedLibrary:''
		}
	},
  props: {
	'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String
  },
  emits: ["changeAfterSelect"],
  components: {
    
  }
  ,mounted () {

  },
  
	methods: {
		//tinymce select one document
		//natiahne dokumenty pre vyber jedneho do clanku
		loadDocuments:function(){
			
			getLibraryInfo({libraryId:this.selectedLibrary}).then(response => {
				if(!response.statusText){
					this.library = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			if(this.selectedLibrary){
				this.preloader=true
				getDocumentsByLibrary({libraryId:this.selectedLibrary}).then(response => {
					if(!response.statusText){
						this.preloader=false
						this.docs = response.documents;
					}else{
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.docs=[];
			}
		
		},

		loadLibraries:function(){
				
			this.preloader=true
			
			getLibraryOptions().then(response => {
				if(!response.statusText){
					this.preloader=false
					this.optionsLibraries = response.optionsLibraries;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},

		onSelect:function(e){
			this.$emit('changeAfterSelect', e)
			this.toast.success(this.$t('msgCore.documentWasSelected'));
		},

		onCloseModal:function(){
			this.modalObject.hide();
		}

	},
	
	watch: {
		modalId() {
			this.loadLibraries();
		},
	},
	
	created() {

	}
})
</script>

<template>
  <div>
    <div class="modal fade" :id="modalId" tabindex="-1" >
		<div class="modal-dialog modal-fullscreen modal-dialog-scrollable">	
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.Preview') }} <b><span>{{ library.title }}</span></b></h6>
				</div>
				
				<div class="modal-body">
				
					<div class="form-group col-md-4 col-12">
						<label><b>{{ $t('msgCore.Library') }}</b></label>
						<select v-model='selectedLibrary' class="form-control form-control-sm" v-on:change="loadDocuments()">
							<option  value="">{{ $t('msgCore.selectLibrary') }}</option>
							<option v-for="(option) in optionsLibraries" :value="option.value" :key="option">{{ option.title }}</option>
						</select>
					</div>

					<div class="row">
						<div class="col-12">
							<table class="table table-sm table-hover">
							
								<tr v-for="doc in docs" :key="doc.id">
									<td>{{doc.title}}</td>
									<td>
										<div class="btn-group">
											<button type="button" v-on:click="onSelect(doc.id)" :title="$t('msgCore.btnSelectDocument')" id="myModalBtn" class="btn btn-primary btn-sm" style="">vložiť</button>
										
										</div>
									</td>
								</tr>
							
							</table>
						</div>
					</div>						
				</div>
				
				<div class="modal-footer">
					<div class="btn-group">
						<button type="button" v-on:click="onCloseModal()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
					</div>	
				</div>
					
			</div>

		</div>
		
	</div>  

  </div>
</template>